/**
 * @generated SignedSource<<a9a0be146bbf7daeaff874a56b51c195>>
 * @relayHash 2e3bbc385de15ab66bc9bdff4ffe8691
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2e3bbc385de15ab66bc9bdff4ffe8691

import { ConcreteRequest } from 'relay-runtime';
export type BetterDocRejectionReason = "BETTER_DOC_CHOSE_CARE_PROVIDER_BEFOREHAND" | "PATIENT_REFUSES_TO_USE_BETTER_DOC";
export type Gatekeeper = "GENERAL_PRACTITIONER" | "MEDGATE_AND_OTHERS" | "MEDGATE_ONLY" | "NOT_MEDGATE" | "NO_GATEKEEPER";
export type PointOfCareType = "EMERGENCY_CALL" | "EXTERNAL_ASSISTANCE" | "GENERAL_PRACTITIONER" | "HOSPITAL_ELECTIVE" | "HOSPITAL_EMERGENCY_ROOM" | "INCOMPLETE_TELECONSULTATION" | "MEDICAL_EMERGENCY_OR_PERMANENCE" | "SPECIALIST" | "TELECARE";
export type ReasonForChoosingType = "INFRASTRUCTURE" | "PATIENT_REQUEST" | "TIME";
export type ResolvedBetterDocUsage = "ALLOWED" | "NOT_ALLOWED" | "REQUIRED";
export type TimeToTreatType = "LATER" | "URGENT" | "WITHIN12H" | "WITHIN14DAYS" | "WITHIN24H" | "WITHIN48H" | "WITHIN6H";
export type Ch_updateProgressNotePointOfCareInput = {
  actualPointOfCare?: PointOfCareType | null;
  careProviderId?: string | null;
  id: string;
  isBetterDocSuggestion?: boolean | null;
  isDoctorVisitAvoided?: boolean | null;
  medicalPointOfCare: PointOfCareType;
  patientGatekeepers?: ReadonlyArray<Gatekeeper> | null;
  purpose?: PurposeInput | null;
  reasonForChoosingActualType?: ReasonForChoosingType | null;
  resolvedBetterDocUsage?: ResolvedBetterDocUsage | null;
  specialtyId?: string | null;
  timeToTreatType?: TimeToTreatType | null;
};
export type PurposeInput = {
  instrumentalExamination?: boolean | null;
  laboratory?: boolean | null;
  physicalExam?: boolean | null;
};
export type chUpdateProgressNotePointOfCareMutation$variables = {
  input: Ch_updateProgressNotePointOfCareInput;
};
export type chUpdateProgressNotePointOfCareMutation$data = {
  readonly updateProgressNotePointOfCare: {
    readonly ProgressNoteMutationOutput: {
      readonly episodeOfCare: {
        readonly id: string;
        readonly updatedAt: string;
      } | null;
      readonly progressNote: {
        readonly betterDoc: {
          readonly isUsed: boolean | null;
          readonly rejectionReason: BetterDocRejectionReason | null;
        } | null;
        readonly pointOfCare: {
          readonly actual: PointOfCareType | null;
          readonly careProvider: {
            readonly id: string;
          } | null;
          readonly careProviderId: number | null;
          readonly careProviderSpecialty: {
            readonly id: string;
            readonly name: string;
            readonly specialtyTranslations: ReadonlyArray<{
              readonly id: string;
              readonly language: string;
              readonly name: string;
              readonly specialtyId: number;
            }>;
          } | null;
          readonly isDoctorVisitAvoided: boolean | null;
          readonly medical: PointOfCareType;
          readonly pointOfCareSpecialty: {
            readonly careProviderSpecialty: {
              readonly id: string;
              readonly name: string;
            } | null;
            readonly id: string;
            readonly specialtyTranslations: ReadonlyArray<{
              readonly language: string;
              readonly name: string;
            }>;
            readonly synonym: string | null;
            readonly word: string;
          } | null;
          readonly purpose: {
            readonly instrumentalExamination: boolean | null;
            readonly laboratory: boolean | null;
            readonly physicalExam: boolean | null;
          } | null;
          readonly reasonForChoosingActual: ReasonForChoosingType | null;
          readonly specialtyId: number | null;
          readonly timeToTreatType: TimeToTreatType | null;
        } | null;
        readonly updatedAt: string;
      };
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type chUpdateProgressNotePointOfCareMutation = {
  response: chUpdateProgressNotePointOfCareMutation$data;
  variables: chUpdateProgressNotePointOfCareMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "ch_EpisodeOfCare",
  "kind": "LinkedField",
  "name": "episodeOfCare",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    (v3/*:: as any*/)
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "ch_ProgressNoteBetterDoc",
  "kind": "LinkedField",
  "name": "betterDoc",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isUsed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rejectionReason",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "specialtyId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "language",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "ch_PointOfCare",
  "kind": "LinkedField",
  "name": "pointOfCare",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "medical",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actual",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reasonForChoosingActual",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDoctorVisitAvoided",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "careProviderId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Purpose",
      "kind": "LinkedField",
      "name": "purpose",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "physicalExam",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "laboratory",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "instrumentalExamination",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v6/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Specialty",
      "kind": "LinkedField",
      "name": "careProviderSpecialty",
      "plural": false,
      "selections": [
        (v2/*:: as any*/),
        (v7/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "SpecialtyTranslation",
          "kind": "LinkedField",
          "name": "specialtyTranslations",
          "plural": true,
          "selections": [
            (v2/*:: as any*/),
            (v8/*:: as any*/),
            (v7/*:: as any*/),
            (v6/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PointOfCareSpecialty",
      "kind": "LinkedField",
      "name": "pointOfCareSpecialty",
      "plural": false,
      "selections": [
        (v2/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "word",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "synonym",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PointOfCareSpecialtyTranslation",
          "kind": "LinkedField",
          "name": "specialtyTranslations",
          "plural": true,
          "selections": [
            (v8/*:: as any*/),
            (v7/*:: as any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Specialty",
          "kind": "LinkedField",
          "name": "careProviderSpecialty",
          "plural": false,
          "selections": [
            (v2/*:: as any*/),
            (v7/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timeToTreatType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CareProvider",
      "kind": "LinkedField",
      "name": "careProvider",
      "plural": false,
      "selections": [
        (v2/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "chUpdateProgressNotePointOfCareMutation",
    "selections": [
      {
        "alias": "updateProgressNotePointOfCare",
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_updateProgressNotePointOfCarePayload",
        "kind": "LinkedField",
        "name": "ch_updateProgressNotePointOfCare",
        "plural": false,
        "selections": [
          {
            "alias": "ProgressNoteMutationOutput",
            "args": null,
            "concreteType": "ch_ProgressNoteMutationOutput",
            "kind": "LinkedField",
            "name": "ch_ProgressNoteMutationOutput",
            "plural": false,
            "selections": [
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ch_ProgressNote",
                "kind": "LinkedField",
                "name": "progressNote",
                "plural": false,
                "selections": [
                  (v3/*:: as any*/),
                  (v5/*:: as any*/),
                  (v9/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v10/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "chUpdateProgressNotePointOfCareMutation",
    "selections": [
      {
        "alias": "updateProgressNotePointOfCare",
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_updateProgressNotePointOfCarePayload",
        "kind": "LinkedField",
        "name": "ch_updateProgressNotePointOfCare",
        "plural": false,
        "selections": [
          {
            "alias": "ProgressNoteMutationOutput",
            "args": null,
            "concreteType": "ch_ProgressNoteMutationOutput",
            "kind": "LinkedField",
            "name": "ch_ProgressNoteMutationOutput",
            "plural": false,
            "selections": [
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ch_ProgressNote",
                "kind": "LinkedField",
                "name": "progressNote",
                "plural": false,
                "selections": [
                  (v3/*:: as any*/),
                  (v5/*:: as any*/),
                  (v9/*:: as any*/),
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v10/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "2e3bbc385de15ab66bc9bdff4ffe8691",
    "metadata": {},
    "name": "chUpdateProgressNotePointOfCareMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "a578fe1a4e95ff1d59844792b15276c2";

export default node;
